// extracted by mini-css-extract-plugin
export default {"logo":"HeaderLogo_logo__48LSH","logoTextContainer":"HeaderLogo_logoTextContainer__72poy"};